import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SvgIconComponent, SvgIcons } from '@ngneat/svg-icon';
import { TranslatePipe } from '@ngx-translate/core';

import { IsDefinedPipe } from '@shared/pipes/is-defined';

import { StatusViewModelEnum } from './status.view-model';

@Component({
  selector: 'app-status',
  imports: [NgClass, IsDefinedPipe, SvgIconComponent, TranslatePipe],
  templateUrl: './status.component.html',
  styleUrl: './status.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatusComponent {
  public status = input.required<StatusViewModelEnum>();
  public value = input<string | number>();
  public icon = input<SvgIcons>();
  public acrossSiteCount = input<number>();

  public readonly StatusViewModelEnum = StatusViewModelEnum;
}
